import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { RouterProvider } from 'react-router'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthProvider } from '@/features/auth/AuthProvider'
import { toAppError } from '@/lib/errors'
import { hydrateInitialData } from '@/lib/initial-data'
import { setupQueryPersistence } from '@/lib/query-persist'
import { router } from './router'

const NO_RETRY = new Set(['not_found', 'not_authenticated', 'forbidden', 'invalid_input'])

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => failureCount < 2 && !NO_RETRY.has(toAppError(error).code),
    },
    mutations: {
      retry: false,
    },
  },
})

// Propostas, categorias, configurações e indicadores ficam salvos no navegador por até 24 h:
// a visita seguinte já abre com eles e atualiza em segundo plano. Dados da conta, nunca.
const persistOptions = setupQueryPersistence(queryClient)

// Na primeira visita a uma proposta ou à lista, os dados já vêm na página (Pages Function).
hydrateInitialData(queryClient)

export function App() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <AuthProvider>
        <TooltipProvider delayDuration={300}>
          <RouterProvider router={router} />
          <Toaster position="bottom-center" richColors={false} closeButton />
        </TooltipProvider>
      </AuthProvider>
    </PersistQueryClientProvider>
  )
}
